import widgetService from '../_service/widget.service'

export const createBlobUrl = (data: string) => {
  const blob = new Blob([data], { type: 'text/html' })
  return URL.createObjectURL(blob)
}

export const revokeBlobUrl = (url: string) => {
  URL.revokeObjectURL(url)
}

export const handleTiptopPayment = async (
  setBlobUrl: (url: string) => void
) => {
  const data = await widgetService.addTipTopCard().then((res: any) => res.data)

  const url = createBlobUrl(data)
  setBlobUrl(url)

  return () => revokeBlobUrl(url)
}

export const addMessageListener = (
  handleCloseIframe: () => void,
  onConfirm: () => void,
  onClose?: () => void
) => {
  const handleMessage = (event: MessageEvent) => {
    if (
      event.data?.type === 'TIPTOP_SUCCESS' ||
      event.data?.type === 'TIPTOP_FAIL'
    ) {
      handleCloseIframe()
    }

    if (event.data?.type === 'TIPTOP_SUCCESS') {
      onConfirm()
      onClose?.()
    }
  }

  window.addEventListener('message', handleMessage)
  return () => window.removeEventListener('message', handleMessage)
}
